(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pesticides-meta-table"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buildTable = (section) => {
      const tbody = section.querySelector('.pesticides-meta-table__body');
      const sourceFields = section.querySelectorAll('.pesticides-meta-table__source-item');

      if (!tbody || !sourceFields.length) {
        return;
      }

      const falseLabel = tbody.dataset.falseLabel || 'Not detected';
      const rows = [];

      sourceFields.forEach((field) => {
        try {
          const value = JSON.parse(field.textContent || 'null');

          if (Array.isArray(value)) {
            value.forEach((item) => {
              const name = String(item || '').trim();
              if (name) {
                rows.push(name);
              }
            });
            return;
          }

          if (typeof value === 'string') {
            value
              .split(/\r\n|\r|\n/g)
              .map((item) => item.trim())
              .filter(Boolean)
              .forEach((item) => rows.push(item));
          }
        } catch (error) {
          return;
        }
      });

      tbody.innerHTML = rows
        .map((name) => {
          const escapedName = name
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

          return `
            <tr>
              <td>${escapedName}</td>
              <td>
                <span class="pesticides-meta-table__status pesticides-meta-table__status--false">${falseLabel}</span>
              </td>
            </tr>
          `;
        })
        .join('');

      section.dataset.pesticidesReady = 'true';
    };

    const init = (root) => {
      root.querySelectorAll('.pesticides-meta-table').forEach((section) => {
        buildTable(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) {
        init(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
